import { Injectable, Inject, NgZone, Injector, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginViewModel } from 'src/app/layouts/public/login/models/login-view-model';
import { isNullOrUndefined } from 'src/app/helpers/tools';
import { TokenResult, TokenResultClass } from 'src/app/layouts/public/login/models/tokenresult';
import { TokenContent } from 'src/app/layouts/public/login/models/tokenContent';
import { UserIdleService } from 'angular-user-idle';
import {ActivatedRoute, Router} from '@angular/router';
import { ChangePassword } from 'src/app/layouts/public/login/models/changePassword';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/internal/operators/take';
import { map } from 'rxjs/internal/operators/map';
import { SharedDataService } from 'src/app/layouts/secure/settings/shared-data/shared-data.service';
import {firstValueFrom} from "rxjs/internal/firstValueFrom";
import {timeout} from "rxjs/operators";
import { IUserAccount } from '../models/userAccount';
import { Distributor } from 'src/app/layouts/secure/settings/supply-chain/models/Distributor';
import {Contact} from "src/app/layouts/secure/settings/supply-chain/models/Contact";
import rg4js, { RaygunV2UserDetails } from 'raygun4js';
import {RaygunStateService} from "src/app/shared/services/raygun-state.service";
import {JWTHelper} from "src/app/helpers/jwt.helper";
import {PermissionHelper} from "src/app/helpers/permission.helper";
import {ICountry, IRegion} from "src/app/layouts/secure/settings/supply-chain/accounts/interfaces/accounts-interface";
import {HeadServiceService} from "../../../../shared/services/head-service.service";
import {ServerHubService} from "../../../../shared/services/serverHub.service";
import {StyleService} from "../../../../shared/components/style/style.service";
import {environment} from "../../../../../environments/environment";
import {LogoutAllConfirmComponent} from "../../../../shared/components/logout-all-confirm/logout-all-confirm.component";
import {AutoLogoutComponent} from "../../../../shared/components/auto-logout/auto-logout.component";
import {ErrorCode} from "src/app/shared/models/ErrorCode";
import {ImageSlider} from "src/app/shared/components/slider/models/imageSlider";
import {SupplyChainStateService} from "../../../secure/settings/supply-chain/services/supply-chain-state.service";
import {ManagementStateService} from "../../../secure/settings/supply-chain/accounts/services/accounts-state.service";
import {LinkExpiredRequest} from "../models/LinkExpiredRequest";
import {EmailConfirmationRequest} from "../models/EmailConfirmationRequest";
import {ResendActivationEmailRequest} from "../models/ResendActivationEmailRequest";
import {tap} from "rxjs/internal/operators/tap";
import {Provider} from "../../../secure/settings/shared-data/countries/selected/providers/models/Provider";

@Injectable({
    providedIn: 'root'
})
export class LoginServerService {

    private userUseIdle: UserIdleService;

    private userIdleSubscriptions: Subscription[] = [];

    public defaultIdleTime = 60.0 * 15.0; // 15 minutes
    public timeoutTime = 60.0;
    public bufferTime = 30.0;

    private idleCallbackTimeout = null;

    public timeoutRemaining: number;
    private _modalRef: NgbModalRef;
    public isPopupOpen: boolean = false;
    private _modalService: NgbModal;
    userAccounts: IUserAccount[];
    
    public loginPageMessaage = "";
    public messageColour = "";
    public preFillEmail = "";

    public currentAccountChangedNotify = new EventEmitter();
    
    public isChangingAccount: boolean = false;

    public userName: string;

    constructor(private _http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private _router: Router,
        private serverHubService: ServerHubService, private _supplyChain: SupplyChainStateService,
        private _managementService: ManagementStateService, private _sharedDataService: SharedDataService, private _ngZone: NgZone,
        private _headService: HeadServiceService, private _styleService: StyleService, private _injector: Injector, private _raygunStateService: RaygunStateService,
        private _route: ActivatedRoute) {
    }
    
    public async preSetup() {
        this.serverHubService.setupCurrentAccountChangedNotify(this.currentAccountChangedNotify);

        window.addEventListener("storage", (e) => this.checkStillLogin(e), true);

        await this.loadDefaultIdleTime();
    }

    public async setup(isSSO: boolean = false) {
        // check if refresh token is still valid need to not force redirect
        if (!isSSO)
            await this.refreshTokenIfPossible(false);
        
        await this.setupUserIdle();
        this.setupServerLogoutCheck();
        this._headService.setTitle(null);
    }

    private clearingToken: boolean = false;

    private checkStillLogin(e: StorageEvent) {
        console.log("checkStillLogin e");
        console.log(e);

        if (this.clearingToken) {
            console.log("Was clearing token")
            return;
        }

        if (e.key == 'jwt') {
            console.log("jwt updated");
            if (!this.checkLoginStatus()) {
                console.log("no longer signed in");
                this.localLogout();
            } else {
                console.log("still signed in");
            }
        }
    }

    private setupServerLogoutCheck() {
        this.serverHubService.addHandler("LogoutUser", (userId) => this.logoutIfUser(userId));
    }

    public async logoutIfUser(userId: string) {
        console.log("Asked to logout user: " + userId);

        console.log("Current userId: " + this.cachedUserId);

        // only logout requested user
        if (this.cachedUserId == userId) {
            await this.localLogout();
        } else {
            // check if still logged in
            if (!this.userToken) {
                await this.localLogout();
            }
        }
    }

    public async logoutAllIfUser(userId: string) {
        console.log("Logout All Asked to logout user: " + userId);

        console.log("Current userId: " + this.cachedUserId);

        // only logout requested user
        if (this.cachedUserId == userId || !this.userToken) {
            this.clearingToken = true; // prevent refresh token renewal caused by signalr client
            this.setUserSettings(null);
        }
    }

    public async localLogout(returnUrl?: string) {
        await firstValueFrom(this.accountLogout(false));

        if (returnUrl) {
            await this._router.navigate(["/"], { queryParams: { returnUrl: returnUrl } });
        }
        else {
            await this._router.navigate(['/']);
        }
    }

    public timeoutPercent() {
        return (this.timeoutRemaining / this.timeoutTime) * 100.0;
    }

    public async remainSignedIn() {
        // stop timeout
        this.stopUserIdle();

        // refresh token
        await this.refreshTokenIfPossible();
    }

    private stopUserIdle() {
        if (this.idleCallbackTimeout) {
            clearTimeout(this.idleCallbackTimeout);
        }

        if (this.isPopupOpen) {
            this.closeAutoLogout();
        }

        for (let i = this.userIdleSubscriptions.length - 1; i >= 0; i--) {
            const sub = this.userIdleSubscriptions[i];
            sub.unsubscribe();
        }

        this.userUseIdle = null;
    }

    private async refreshTokenIfPossible(redirect: boolean = true) {
        let refreshResult: TokenResult = null;

        try {
            refreshResult = await this.getNewRefreshToken().toPromise();
        } catch (e) {
            // intentionally blank
        }

        if (!refreshResult.success) {
            // could not refresh token, logout user

            this.stopUserIdle();

            console.log("Logging out due to refresh token failure")
            await this.accountLogout().toPromise();
            if (redirect) {
                await this._router.navigate(['/']);
            }
            return false;
        }

        return refreshResult.success;
    }

    private async setupUserIdle() {
        this.stopUserIdle();
        console.log("Checking users token");

        let tokenRemainingTime = this.tokenRemainingLifetime();

        if (tokenRemainingTime === null) {
            // had no token
            return;
        }

        if (tokenRemainingTime <= this.timeoutTime) {
            console.log("Renewing users token");
            // within token expiry countdown time or token has expired, try to renew
            if (!await this.refreshTokenIfPossible()) {
                return;
            }
        }

        // take off the countdown time
        var idleTime = this.defaultIdleTime;

        if (this.userToken && this.userToken.remember_me) {
            // remember me selected so don't alert until refresh token is within a minute of expiry
            idleTime = tokenRemainingTime - this.timeoutTime;

            const dayInSeconds = (60.0 * 60.0 * 24.0);

            if (idleTime > (dayInSeconds)) { // greater than 24 hours
                console.log("Wait a day before starting the idle check");
                this.idleCallbackTimeout = setTimeout(() => this.setupUserIdle(), dayInSeconds * 1000.0);
                return;
            }
        }

        const pingTime = tokenRemainingTime - this.bufferTime;

        this.timeoutRemaining = this.timeoutTime;

        this.userUseIdle = new UserIdleService({ idle: idleTime, timeout: this.timeoutTime, ping: pingTime }, this._ngZone);

        this.userUseIdle.startWatching();

        const idleTimerStartSub = this.userUseIdle.onTimerStart().subscribe(async (count) => {
            const tokenRemainingTime = this.tokenRemainingLifetime();

            if (!this.isPopupOpen) {
                console.log("Timer start - Opening auto logout popup");
                this.openAutoLogout();
            }
            this.timeoutRemaining = this.timeoutTime - count;
        });
        this.userIdleSubscriptions.push(idleTimerStartSub);

        const idleTimeoutSub = this.userUseIdle.onTimeout().subscribe(async () => {
            // Just remove browser local storage as there may be other active browsers
            console.log("Forcing user logout");
            await this.localLogout();
        });
        this.userIdleSubscriptions.push(idleTimeoutSub);

        const pingSub = this.userUseIdle.ping$.subscribe(async () => {
            if (!this.isPopupOpen) {
                const tokenRemainingTime = this.tokenRemainingLifetime();
                                
                // renew if within buffer time
                if (tokenRemainingTime < this.bufferTime) {
                    // stop user idle as the token is being renewed
                    this.stopUserIdle();

                    console.log("Ping - Refreshing users token if needed");
                    if (!await this.refreshTokenIfPossible()) {
                        return;
                    }
                }
            }
        });
        this.userIdleSubscriptions.push(pingSub);

    }

    private loadToken() {
        if (this._raygunStateService.useRaygun) {
            if (isNullOrUndefined(this.userToken) || isNullOrUndefined(this.userToken.nameid)) {
                var anonymousUser: RaygunV2UserDetails = { isAnonymous: true, identifier: null };
                rg4js('setUser', anonymousUser);
                rg4js('getRaygunInstance').resetAnonymousUser();
            } else {
                rg4js('setUser', {
                    identifier: this.userToken.nameid,
                    isAnonymous: false,
                    email: this.userToken.unique_name,
                    fullName: this.userToken.given_name
                });
            }
        }
    }

    public get userToken(): TokenContent {// = new TokenContent();
        const token = localStorage.getItem('jwt');
        return JWTHelper.decodeJwt(token);
    }

    public async userAccountList() {
        await this.getUserAccounts().toPromise();
        return this.userAccounts;
    }

    /**
     * Returns the remaining lifetime of the current JWT token
     * */
    public tokenRemainingLifetime(): number {
        // ensure the current token in loaded

        if (isNullOrUndefined(this.userToken) || isNullOrUndefined(this.userToken.exp)) {
            return null;
        }

        const expiryTime = new Date(0);

        if (this.userToken.remember_me) {
            // use Refresh token expiry
            expiryTime.setUTCSeconds(+(localStorage.getItem('refreshTokenExpiry')));
        } else {
            // use JWT token expiry
            expiryTime.setUTCSeconds(this.userToken.exp);
        }

        const currentTime = new Date();

        const remainingTimeMilliSec = expiryTime.getTime() - currentTime.getTime();

        const remainingTimeSec = remainingTimeMilliSec / 1000;

        return remainingTimeSec;
    }

    /**
     * Determine if the current user is in the specified role
     * @param roleName The rule to check if the user is a member of
     */
    public inRole(roleName: string): boolean {
        return this.inAnyRole([roleName]);
    }

    /**
     * Determine if the current user is in any of the specified roles
     * @param roleNames The rule to check if the user is a member of
     */
    public inAnyRole(roleNames: string[]): boolean {
        if (isNullOrUndefined(this.userToken) || isNullOrUndefined(this.userToken.role)) {
            return false;
        }

        if (isNullOrUndefined(roleNames) || roleNames.length === 0) {
            return true;
        }

        if (typeof this.userToken.role === "string") {
            return roleNames.findIndex(ro => ro === this.userToken.role) !== -1;
        } else {
            return this.userToken.role.findIndex(r => roleNames.findIndex(ro => ro === r) !== -1) !== -1;
        }
    }

    public isFarmUser(): boolean {
        return PermissionHelper.isAccountUser();
    }

    public isFieldUser(): boolean {
        return PermissionHelper.isSiteUser();
    }

    public isDistributorUser(): boolean {
        return PermissionHelper.isDistributorUser();
    }

    public isGroupUser(): boolean {
        return PermissionHelper.isGroupUser();
    }

    public isSiteUser(): boolean {
        return PermissionHelper.isSiteUser();
    }

    public isSuperUser(): boolean {
        return PermissionHelper.hasAllPermissions();
    }

    /**
     * User has no roles
     * @returns
     */
    public isNewUser(): boolean {        
        return PermissionHelper.isNewUser();
    }

    /**
     * Identify if the current account or laboratory has subscriptions
     * @returns
     */
    public hasSubs(): boolean {
        return PermissionHelper.hasSubs();
    }

    // Used to keep a record of the last userId this browser session was aware of as token may have been removed when other browser logs out
    private get cachedUserId(): string {
        if (this.userToken) {
            return this.userToken.sub;
        } else {
            return null;
        }
    }

    private setUserSettings(userSettings: TokenResult) {
        var decodedJWT = null;
        if (!isNullOrUndefined(userSettings) && userSettings.success) {
            decodedJWT = JWTHelper.decodeJwt(userSettings.token);
        }
        if (userSettings && !environment.production) {
            console.log(decodedJWT);
        }
        
        if (this._raygunStateService.useRaygun) {
            if (isNullOrUndefined(userSettings) || !userSettings.success) {
                rg4js('setUser', {
                    identifier: this._raygunStateService.anonymousId,
                    isAnonymous: true
                });
            } else {
                this._raygunStateService.clearAnonymousId();
                rg4js('setUser', {
                    identifier: decodedJWT.sub,
                    isAnonymous: false,
                    email: decodedJWT.unique_name,
                    fullName: decodedJWT.given_name
                });
            }
        }
        
        if (!isNullOrUndefined(userSettings) && userSettings.success) {
            // setup local storage
            localStorage.setItem('refreshToken', userSettings.refreshToken);
            localStorage.setItem('refreshTokenExpiry', userSettings.refreshTokenExpiry.toString());
            localStorage.setItem('jwt', userSettings.token);

            this.userName = decodedJWT.given_name;

            this.setupUserIdle();
        } else {
            // clear local storage

            localStorage.removeItem('jwt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('refreshTokenExpiry');

            if (!isNullOrUndefined(localStorage.getItem("UserId"))) {
                localStorage.clear();
            }

            this.userName = null;
        }

        this._styleService.getUsersStyles();

        this.currentAccountChanged();

        return userSettings;
    }

    private accountLoginSubject: BehaviorSubject<TokenResult> = new BehaviorSubject<TokenResult>(null);
    private accountLoginRunning = false;
    
    public get loginRunning() {
        return this.accountLoginRunning;
    }

    public accountLogin(loginModel: LoginViewModel): Observable<TokenResult> {
        if (this.accountLoginRunning) {
            return this.accountLoginSubject.pipe(
                filter(token => token !== null),
                take(1));
        } else {
            this.accountLoginRunning = true;

            // Reset here so that the following requests wait until the token comes back from the refresh token API call
            this.accountLoginSubject.next(null);

            if ((!isNullOrUndefined(loginModel.accountId) || !isNullOrUndefined(loginModel.laboratoryId)
                || !isNullOrUndefined(loginModel.distributorId) || !isNullOrUndefined(loginModel.labGroupId) || loginModel.loginAsGlobal)
                && loginModel.grantType === "refresh_token") {
                loginModel.refreshToken = localStorage.getItem('refreshToken');
                loginModel.rememberMe = this.userToken.remember_me; // keep remember me state
            }

            return this._http
                .post<TokenResult>(this.baseUrl + 'api/RefreshToken/Login', loginModel)
                .pipe(
                    map((userSettings: TokenResult) => {
                        if (this.clearingToken) {
                            console.log("accountLogin() result but clearingToken = true");

                            userSettings = null;
                        }
                        return userSettings;
                    }),
                    tap(async (userSettings: TokenResult) => {
                        await this.setUserSettings(userSettings);

                        this.accountLoginSubject.next(userSettings);

                        this.accountLoginRunning = false;
                        this.isChangingAccount = false;
                    }),
                    catchError(error => {
                        const errorResult = this.handleError(error);

                        this.accountLoginRunning = false;
                        this.isChangingAccount = false;

                        return errorResult;
                    }));
        }
    }

    public async loginWithToken(userSettings: TokenResult) {
        this.setUserSettings(userSettings);

        this.accountLoginSubject.next(userSettings);

        this.accountLoginRunning = false;
        this.isChangingAccount = false;
    }

    public async accountLogoutSelected(everywhere: boolean = false) {
        if (everywhere) {
            let ngbModalOptions: NgbModalOptions = {
                backdrop: 'static',
                keyboard: false,
                centered: true,
                windowClass: "open-modal",
            };
            this._modalService = this._injector.get(NgbModal);
            let logoutModelRef = this._modalService.open(LogoutAllConfirmComponent, ngbModalOptions);
            let modal = logoutModelRef.componentInstance as LogoutAllConfirmComponent;
            modal.logOut = async () => {
                logoutModelRef.dismiss();
                console.log("Manual log out 1");
                await this.accountLogout(everywhere).toPromise();
                this._router.navigate(['/']);
            };
            modal.remainSignedIn = () => {
                logoutModelRef.dismiss();
            };
        } else {
            console.log("Manual log out 2");
            await this.accountLogout(everywhere).toPromise();
            this._router.navigate(['/']);
        }
    }

    /**
     * Logout the current user based on the refresh token
     * */
    public accountLogout(everywhere: boolean = false): Observable<any> {
        this._supplyChain.clearSelectedDistributor();
        this._supplyChain.clearSelectedGroup();
        this._supplyChain.clearSelectedSite();
        this._managementService.clearSelectedAccount();
        this._managementService.clearSelectedProperty();
        this._sharedDataService.clearSelectedProduct();
        this.stopUserIdle();

        const refreshToken = localStorage.getItem('refreshToken');

        return this._http
            .get(this.baseUrl + 'api/RefreshToken/Logout?refreshToken=' + refreshToken + "&everywhere=" + everywhere)
            .pipe(map((data) => {
                // clear set properties
                console.log("Logging out");
                this.setUserSettings(null);
                return data;
            }),
            catchError(this.handleError));
    }

    /**
     * Logout the a user based on the userId
     * */
    public userLogout(userId: string): Observable<any> {
        return this._http
            .get(this.baseUrl + 'api/RefreshToken/LogoutUser?userId=' + userId)
            .pipe(catchError(this.handleError));
    }

    /**
     * Method to get new refresh token
     * */
    getNewRefreshToken(): Observable<TokenResult> {
        if (this.clearingToken) {
            console.log("getNewRefreshToken() but clearingToken = true");
            var tokenResult: TokenResult = new TokenResultClass(false);
            return of(tokenResult);
        }

        const username = this.userToken.unique_name;
        const refreshToken = localStorage.getItem('refreshToken');
        const grantType = "refresh_token";
        const rememberMe = this.userToken.remember_me;
        var accountName = null;
        const accountId = this.userToken.Rata_AccountId;
        const laboratoryId = this.userToken.Rata_LaboratoryId;
        const distributorId = this.userToken.Rata_DistributorId;
        const laboratoryGroupId = this.userToken.Rata_LaboratoryGroupId;

        if (!isNullOrUndefined(accountId)) {
            accountName = this.userToken.Rata_AccountName;
        }
        else if (!isNullOrUndefined(laboratoryId)) {
            accountName = this.userToken.Rata_LaboratoryName;
        }
        else if (!isNullOrUndefined(distributorId)) {
            accountName = this.userToken.Rata_DistributorName;
        }
        else if (!isNullOrUndefined(laboratoryGroupId)){
            accountName = this.userToken.Rata_LaboratoryGroupName;
        }

        const loginModel = new LoginViewModel();

        loginModel.userName = username;
        loginModel.refreshToken = refreshToken;
        loginModel.grantType = grantType;
        loginModel.rememberMe = rememberMe;
        loginModel.accountName = accountName;
        loginModel.accountId = accountId;
        loginModel.laboratoryId = laboratoryId;
        loginModel.distributorId = distributorId;
        loginModel.labGroupId = laboratoryGroupId;

        if (PermissionHelper.isSuperiorUser() && PermissionHelper.inRole(["NewUser"])) {
            loginModel.loginAsGlobal = true;
        }

        return this.accountLogin(loginModel);
    }

    checkLoginStatus(): boolean {
        return !isNullOrUndefined(this.userToken.sub);
    }

    connectToMicroI(address) {
        return this._http
            .get<string>(this.baseUrl + 'api/RefreshToken/ConnectToMicroI?ip=' + address)
            .pipe(catchError(this.handleError));
    }

    requestNewEmail(_userId: any, returnUrl: string, propContactInvite: string | null): any {
        return this._http
            .post(this.baseUrl + `api/RefreshToken/ResendUserActivationNewEmail`, new ResendActivationEmailRequest(_userId, returnUrl, propContactInvite))
            .pipe(catchError(this.handleError));
    }

    getUserRegistrationDetails(_userId: any, _code: any, _confirm: any): Observable<any> {
        return this._http
            .post(this.baseUrl + `api/RefreshToken/GetUserRegistrationDetails`, new EmailConfirmationRequest(_userId, _code, _confirm))
            .pipe(catchError(this.handleError));
    }

    SetOrUpdatePassword(changePassword: ChangePassword): any {
        return this._http
            .post(this.baseUrl + 'api/RefreshToken/SetPassword', changePassword)
            .pipe(catchError(this.handleError));
    }

    checkLinkExpired(userId: any, code: any, proContInviteToken: string): any {
        return this._http
            .post(this.baseUrl + `api/RefreshToken/CheckLinkExpired`, new LinkExpiredRequest(userId, code, proContInviteToken))
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
    //#endregion

    public resetPassword(userEmail, userId, returnUrl: string) {
        return this._http
            .get(this.baseUrl + 'api/RefreshToken/ResetPassword?email=' + encodeURIComponent(userEmail) + '&userId=' + userId + "&returnUrl=" + returnUrl)
            .pipe(catchError(this.handleError));
    }

    public async connectFromDevice(deviceToken, rememberMe, returnUrl, siteId, accountId) {
        // stop timeout to prevent logout during single sign-on
        this.stopUserIdle();

        // clear current logged in user
        console.log("Cleaing token prep for sso signin")
        this.setUserSettings(null);

        var userSettings = await this._http
            .get<TokenResult>(this.baseUrl + 'api/RefreshToken/ConnectFromMicroI?tokenValue=' + deviceToken + '&rememberMe=' + rememberMe + '&siteId=' + siteId + '&accountId=' + accountId + '&returnUrl=' + returnUrl)
            .pipe(catchError(this.handleError)).toPromise();

        return this.setUserSettings(userSettings);

    }

    public openAutoLogout() {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            centered: true,
            windowClass: "open-modal",
        };
        this._modalService = this._injector.get(NgbModal);
        this._modalRef = this._modalService.open(AutoLogoutComponent, ngbModalOptions);
        let modal = this._modalRef.componentInstance as AutoLogoutComponent;
        modal.logOut = this.logMeOut;
        modal.remainSignedIn = this.letMeRemain;
        this.isPopupOpen = true;
    }

    public closeAutoLogout() {
        this._modalRef.dismiss();
        this.isPopupOpen = false;
    }

    public logMeOut = () => this.doLogMeOut();
    public letMeRemain = () => this.remainSignedIn();

    public async doLogMeOut() {
        console.log("Manual log out 3");
        await this.accountLogout().toPromise();
        this._router.navigate(['/']);
    }

    public getSliders(): Observable<ImageSlider[]> {
        return this._http
            .get<ImageSlider[]>(this.baseUrl + 'api/MarketingAndPromotions/GetBackgroundSliders')
            .pipe(catchError(this.handleError));
    }
       

    public getUserAccounts(): Observable<IUserAccount[]> {
        var jwt = JWTHelper.decodeJwt(localStorage.getItem('jwt'));
        let userID;
        if (!isNullOrUndefined(jwt.sub)) {
            userID = jwt.sub;
        } else {
            userID = null;
        }

        return this._http
            .get<IUserAccount[]>(this.baseUrl + "api/RefreshToken/GetUserAccounts?userId=" + userID)
            .pipe(map((userAccounts: IUserAccount[]) => {
                this.userAccounts = userAccounts;

                this.updateAssignedToMultipleAccounts();

                return userAccounts;
            }),

                catchError(this.handleError));

    }
    
    public getDefaultUserAccountId(): Observable<string> {
        var jwt = JWTHelper.decodeJwt(localStorage.getItem('jwt'));
        let userID;
        if (!isNullOrUndefined(jwt.sub)) {
            userID = jwt.sub;
        } else {
            userID = null;
        }
        
        return this._http.get(this.baseUrl + "api/RefreshToken/GetDefaultUserAccountId?userId=" + userID, {responseType: "text"})
            .pipe(catchError(this.handleError));
    }
    
    public async updateUserAccounts(jwt: string) {
        if (jwt) {
            var token = JWTHelper.decodeJwt(jwt);
            let userID;
            if (!isNullOrUndefined(token.sub)) {
                userID = token.sub;
            } else {
                userID = null;
            }
            this.userAccounts = await firstValueFrom(this._http.get<IUserAccount[]>(this.baseUrl + "api/RefreshToken/GetUserAccounts?userId=" + userID));

            this.updateAssignedToMultipleAccounts();

            this.currentAccountChanged();
        }
    }

    public assignedToMultipleAccounts: boolean = false;

    private assignedAccountsCount(systemUserAccounts: IUserAccount[]): number {
        var assignedCount: number = 0;

        if (!systemUserAccounts || systemUserAccounts.length === 0) {
            return 0;
        }

        for (var i = 0; i < systemUserAccounts.length; i++) {
            assignedCount += systemUserAccounts[i].assigned ? 1 : 0;
            
            if (systemUserAccounts[i].systemUserAccounts && systemUserAccounts[i].systemUserAccounts.length > 0) {
                assignedCount += this.assignedAccountsCount(systemUserAccounts[i].systemUserAccounts);
            }
        }

        return assignedCount;
    }

    private updateAssignedToMultipleAccounts() {
        if (!this.userAccounts || this.userAccounts.length == 0) {
            this.assignedToMultipleAccounts = false;
            return;
        }

        // recursively check userAccounts.systemUserAccounts if there are more than one account assigned
        this.assignedToMultipleAccounts = this.assignedAccountsCount(this.userAccounts) > 1;
    }

    public currentAccountInfo(): IUserAccount {       

        var jwt = JWTHelper.decodeJwt(localStorage.getItem('jwt'));
        let id;
        let type;
        let userID;
        let name;
        if (!isNullOrUndefined(jwt.Rata_SystemUserId)) {
            userID = jwt.Rata_SystemUserId;
        }

        if (this.isNewUser()) {
            type = "newuser";
            name = "New User";
        } else if (!isNullOrUndefined(jwt.Rata_AccountId)) {
            id = jwt.Rata_AccountId;
            type = "account";
            name = jwt.Rata_AccountName;
        }
        else if (!isNullOrUndefined(jwt.Rata_LaboratoryId)) {
            id = jwt.Rata_LaboratoryId;
            type = "site";
            name = jwt.Rata_LaboratoryName;
        }
        else if (!isNullOrUndefined(jwt.Rata_LaboratoryGroupId)) {
            id = jwt.Rata_LaboratoryGroupId;
            type = "group";
            name = jwt.Rata_LaboratoryGroupName;
        }
        else if (!isNullOrUndefined(jwt.Rata_DistributorId)) {
            id = jwt.Rata_DistributorId;
            type = "distributor";
            name = jwt.Rata_DistributorName;
        }
        else {
            id = null;
            type = null;
            name = null;
        }

        if (name) {
            if (this.isSuperUser()) {
                name += " - Super";
            } else if (this.isFarmUser()) {
                name += " - Farm";
            } else if (this.isSiteUser()) {
                name += " - Site";
            } else if (this.isDistributorUser()) {
                name += " - Distributor";
            } else if (this.isGroupUser()) {
                name += " - Group";
            }
        }

        let result = <IUserAccount>{};
        result.id = id;
        result.type = type;
        result.name = name;

        return result;
    }

    private _changeAccountPropogating = false;
    public currentAccountChanged() {
        if (this._changeAccountPropogating) {
            return;
        }

        this._changeAccountPropogating = true;
        this.currentAccountChangedNotify.emit();
        this._changeAccountPropogating = false;
    }
    
    public register(contact: Contact, returnURL: string) {
        return this._http.post<boolean | null>(`api/RefreshToken/Register?returnURL=${returnURL}`, contact)
            .pipe(catchError(this.handleError)); 
    }

    public getRecaptchaSiteKey() {
        return this._http.get(`api/RefreshToken/GetRecaptchaSiteKey`, {responseType: "text"})
            .pipe(catchError(this.handleError));
    }
    
    public getCountries() {
        return this._http.get<ICountry[]>(`api/RefreshToken/GetCountry`)
            .pipe(catchError(this.handleError));
    }

    public getRegions(countryId) {
        return this._http.get<IRegion[]>(`api/RefreshToken/GetRegions?countryId=${countryId}`)
            .pipe(catchError(this.handleError));
    }

    public getCountryProviders(countryId) {
        return this._http.get<Provider[]>(`api/RefreshToken/GetCountryProviders?countryId=${countryId}`)
            .pipe(catchError(this.handleError));
    }

    public getTestKitSampleInvoicedByProvider(testKitSampleHexId: string) {
        return this._http.get<Provider | null>(`api/RefreshToken/GetTestKitSampleInvoicedByProvider?testKitSampleHexId=${testKitSampleHexId}`)
            .pipe(catchError(this.handleError));
    }
    
    public getDetailsToRefreshToken() {
        var model = new LoginViewModel();
        model.userName = this.userToken.unique_name;
        model.refreshToken = localStorage.getItem('refreshToken');
        model.rememberMe = this.userToken.remember_me;
        return model;
    }
    
    public setRefreshToken(userSettings: TokenResult) {
        this.setUserSettings(userSettings);

        this.accountLoginSubject.next(userSettings);

        this.accountLoginRunning = false;
    }

    private async loadDefaultIdleTime() {
        this.defaultIdleTime = await firstValueFrom(this.getDefaultIdleTime());
    }

    private getDefaultIdleTime() {
        return this._http
            .get<number>(`${this.baseUrl}api/RefreshToken/DefaultIdleTime`)
            .pipe(catchError(this.handleError));
    }
    
    public getErrorDetails(errorCode: number): Observable<ErrorCode> {
        var styleId = this._styleService.currentStyleID != null ? this._styleService.currentStyleID : 0;
        return this._http
            .get<ErrorCode>(`api/ErrorPages/GetErrorDetails?errorCode=${errorCode}&styleId=${styleId}`)
            .pipe(catchError(this.handleError));
    }
    
    public get portalName() {
        return this._styleService.portalTitle;
    }

    public async useGlobalAccount(): Promise<boolean> {
        this.isChangingAccount = true;
        //reset account Id's
        let login_model = new LoginViewModel();

        //reset account id's
        login_model.accountId = null;
        login_model.laboratoryId = null;
        login_model.distributorId = null;
        login_model.labGroupId = null;

        login_model.loginAsGlobal = true;

        login_model.grantType = "refresh_token";
        const data = await firstValueFrom(this.accountLogin(login_model));
        
        return data.success;
    }
}
